import { Component } from "react";
import { connect } from "react-redux";

import { mapActionsIvrToProps } from "../../redux/api-connect/ivr";
import DataTable from "./../../components/api-connect/TableDataIVR";

class Ivrs extends Component {
  componentDidMount() {
    this.props.ivrs && this.props.getIvrsAction();
  }

  render() {
    const {
      ivrs: { items },
    } = this.props;
    const result =
      typeof items === "object"
        ? Object.keys(items).map((key) => items[key])
        : items;
    return (
      <div>
        <DataTable ivrs={result} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ivrs: state.apiConnectIvr.ivrs,
});

export default connect(mapStateToProps, mapActionsIvrToProps)(Ivrs);
